import { useMemo } from 'react';
import { useAppContext } from 'src/AppContextProvider';
import { useLocalStorage } from 'src/domain/useLocalStorage';
import { VENDOR_BILL_ITEM_PAGE_CONST } from './constants';

export const useVendorBillItemsSidebar = () => {
    const { isFiltersSidebarEnabled } = useAppContext();

    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(VENDOR_BILL_ITEM_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        if (!isFiltersSidebarEnabled) return '0';

        return sidebarCollapsed ? '35px' : '200px';
    }, [isFiltersSidebarEnabled, sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
        isFiltersSidebarEnabled,
    };
};
